// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__JOBCQ","total":"Cart_total__+kHE0","actions":"Cart_actions__axKR7","button--alt":"Cart_button--alt__Xpj-s","button":"Cart_button__+rjXM"};